module.exports = __webpack_public_path__ + "img/blue_139.83f69039.png";